import { CiShare1, CiTimer } from "react-icons/ci";
import { FaTextWidth, FaRegCopy } from "react-icons/fa";
import { IoPrintOutline, IoChevronDown, IoChevronUp } from "react-icons/io5";
import { AiOutlineCloudDownload } from "react-icons/ai";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  Button,
  IconButton,
  useTheme,
  Stack,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { PDFDocument, StandardFonts, rgb } from "pdf-lib";
import CloseIcon from "@mui/icons-material/Close";
import EsignModal from "./eSignModal";
import { useState, useRef, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import download from "downloadjs";
import axios from "axios";
import DocumentHistory from "./DocumentHistoryModal";

const ActionModal = ({
  isActionOpen,
  documentData,
  setIsActionOpen,
  setIsModalOpen,
  setIsShareOpen,
  selectedFile,
  docId,
  fileType,
  currentUser,
  byMail,
}) => {
  /* ───── Existing state (rename, duplicate, …) ───── */
  const [isRenameOpen, setIsRenameOpen] = useState(false);
  const [newDocName, setNewDocName] = useState("");
  const [isDuplicateOpen, setIsDuplicateOpen] = useState(false);
  const [history, setHistory] = useState([]);
  const [isCreatingDuplicate, setIsCreatingDuplicate] = useState(false);
  const [isHistoryOpen, setIsHistoryOpen] = useState(false);
  const [name, setName] = useState("");
  const theme = useTheme();

  /** Reset the input whenever the dialog (re)opens */
  useEffect(() => {
    if (isDuplicateOpen) setName("");
  }, [isDuplicateOpen]);

  const handleChange = (e) => {
    // if(isRenameOpen){
    //     setNewDocName(e.target.value);
    // }else{
    setName(e.target.value);
    // }
  };
  const handleConfirm = () => {
    if (name.trim()) {
      console.log(name.trim());
    }
  };

  /** Allow “Enter” to confirm */
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleConfirm();
    }
  };

  /* ───── NEW: collapse state ───── */
  const [showActions, setShowActions] = useState(false);
  const actionsRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState("0px");

  /* Every time we toggle, recompute full content height */
  useEffect(() => {
    if (actionsRef.current) {
      if (showActions) {
        // natural content height
        setMaxHeight(`${actionsRef.current.scrollHeight}px`);
      } else {
        // collapse
        setMaxHeight("0px");
      }
    }
  }, [showActions]);

  // Copy document (create duplicate)
  const handleCopyDocument = () => {
    setIsDuplicateOpen(true);
    setIsActionOpen(false);
  };

  const createDuplicateDocument = async () => {
    try {
      const pdfDocClone = await PDFDocument.load(
        await selectedFile.arrayBuffer()
      );
      //   const helveticaFont = await pdfDocClone.embedFont(
      //     StandardFonts.Helvetica
      //   );

      //   const pages = pdfDocClone.getPages();

      //   // Loop through inputs to add text, date, or signature
      //   for (const input of inputs) {
      //     const { type, position, content, size, pageIndex } = input;
      //     const pageIdx = pageIndex || 0;
      //     const page = pages[pageIdx];
      //     const x = input.x;
      //     const y = page.getHeight() - input.y; // invert y
      //     if (type === "text" || type === "date") {
      //       page.drawText(
      //         type === "date" ? dayjs(content).format("DD/MM/YYYY") : content,
      //         {
      //           x,
      //           y,
      //           size: 14,
      //           font: helveticaFont,
      //         }
      //       );
      //     } else if (type === "signature") {
      //       // Capture the signature from sigPad as Data URL
      //       const signatureBlob = await fetch(signatureImage).then((res) =>
      //         res.blob()
      //       );
      //       const signatureArrayBuffer = await signatureBlob.arrayBuffer();
      //       const signatureImageEmbed = await pdfDocClone.embedPng(
      //         signatureArrayBuffer
      //       );

      //       page.drawImage(signatureImageEmbed, {
      //         x,
      //         y: y - (size?.height || 40), // adjust for image height
      //         width: 50,
      //         height: size?.height || 40,
      //       });
      //     }
      //   }

      const pdfBytes = await pdfDocClone.save();

      const formData = new FormData();
      formData.append("user_id", currentUser?.data?.id || currentUser.id);
      formData.append("document_id", docId);
      formData.append("document_name", name);
      //   formData.append("document_id", docId);
      // formData.append("signature", signatureFile);
      // Check if selectedFile is a Blob and handle it appropriately
      if (selectedFile instanceof Blob) {
        // Create a proper PDF file from the Blob with appropriate naming
        const pdfFile = new File(
          [pdfBytes],
          pdfBytes.name || `document-${Date.now()}.pdf`,
          { type: "application/pdf" }
        );
        formData.append("pdf", pdfFile);
      } else {
        // If it's already a File or other format, append as is
        formData.append("pdf", pdfBytes);
      }
      //   formData.append("position", JSON.stringify(inputs));
      formData.append("fileType", fileType); // Send file type to backend

      let startTime = Date.now();
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}api/prouser/esign-des-documents`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          // onUploadProgress: (progressEvent) => {
          //   const percentCompleted = Math.round(
          //     (progressEvent.loaded * 100) / progressEvent.total
          //   );
          // setUploadProgress(percentCompleted);

          // const timeElapsed = Date.now() - startTime;
          // const uploadSpeed = progressEvent.loaded / (timeElapsed / 1000);
          // const remainingBytes = progressEvent.total - progressEvent.loaded;
          // const estimatedTimeRemaining = remainingBytes / uploadSpeed;
          // setTimeRemaining(estimatedTimeRemaining.toFixed(2));
          // },
        }
      );
      console.log("response", response.data.documentData.document_key);
      if (response.data.success) {
        toast.success(response?.data?.message);
        setIsDuplicateOpen(false);
        window.open(
          `${process.env.REACT_APP_PRO_URL}/prouser/sigmer-des-documents?document_key=${response.data.documentData.document_key}`
        );
      } 
      else 
      {
        toast.error(
          "Erreur lors du téléchargement du fichier. Veuillez réessayer."
        );
      }
    } catch (error) {
      console.error("Upload error:", error);
      //   setUploadError(
      //     "Erreur lors du téléchargement du fichier. Veuillez réessayer."
      //   );
    } finally {
      //   setUploading(false);
    }
  };
  // Show document history
  const handleShowHistory = async () => {
    try {
      const response = await axios.get(
        `${
          process.env.REACT_APP_API_URL
        }api/prouser/get-hostory-data?document_id=${docId}&user_id=${
          currentUser?.data?.id || currentUser?.id
        }`
      );
      const data = await response.data;
      if (data.success) {
        setHistory(data.data);
        setIsHistoryOpen(true);
      }
    } catch (error) {
      setIsHistoryOpen(true);
      console.error("Error fetching history:", error);
    }
    // setShowHistory(true);
    setIsActionOpen(false);
    toast.info("Affichage de l'historique du document");
  };

  // Rename document functionality
  const handleRenameDocument = () => {
    setIsRenameOpen(true);
    setIsActionOpen(false);
  };

  const submitRename = async () => {
    if (!newDocName.trim()) {
      toast.error("Veuillez entrer un nom valide");
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}api/prouser/rename-document`,
        {
          new_file_name: newDocName,
          document_id: docId,
          user_id: currentUser?.data?.id || currentUser.id,
        }
      );
      console.log("response", response);
      if (response.status === 200) {
        toast.success(response?.data?.message);
        setIsRenameOpen(false);
      } else {
        toast.error(
          "Erreur lors du téléchargement du fichier. Veuillez réessayer."
        );
      }
    } catch (error) {
      console.error("Upload error:", error);
      //   setUploadError(
      //     "Erreur lors du téléchargement du fichier. Veuillez réessayer."
      //   );
    } finally {
      setIsRenameOpen(false);
    }
  };

  // Print document
  const handlePrintDocument = () => {
    if (selectedFile) {
      const fileUrl = URL.createObjectURL(selectedFile); // Create Blob URL from the file data

      // Create an iframe to embed the PDF document
      const iframe = document.createElement("iframe");
      iframe.style.position = "absolute";
      iframe.style.top = "-9999px"; // Make it invisible
      iframe.src = fileUrl;

      // Append iframe to the body
      document.body.appendChild(iframe);

      // Wait for the iframe to load and trigger the print dialog
      iframe.onload = () => {
        iframe.contentWindow.print();

        // Clean up the iframe after printing
        // setTimeout(() => {
        //   document.body.removeChild(iframe);
        // }, 1000);
      };

      toast.success("Impression en cours...");
    } else {
      toast.error("Impossible d'imprimer le document");
    }
  };

  // Export/Download document
  const handleExportDocument = async () => {
    if (documentData) {
      try {
        console.log("documentData", documentData);
        // Using download.js for better file download handling
        const pdfDocClone = await PDFDocument.load(
          await selectedFile.arrayBuffer()
        );
        const pdfBytes = await pdfDocClone.save();
        download(pdfBytes, `${documentData?.fileName}.pdf`, "application/pdf");
        toast.success("Document téléchargé avec succès");
      } catch (error) {
        console.error("Error downloading document:", error);
        toast.error("Erreur lors du téléchargement du document");
      }
    } else {
      toast.error("Impossible d'exporter le document");
    }
  };
  /* ───── Render ───── */
  return (
    <>
      <EsignModal isOpen={isActionOpen} onClose={() => setIsActionOpen(false)}>
        <div
          className="border-2 border-gray-300 rounded-lg p-4 mb-4"
          style={{
            overflowY: showActions ? "auto" : "hidden",
            overflowX: "hidden",
          }}
        >
          <h2 className="text-3xl font-bold text-center mb-4">
            Signer votre document
          </h2>
          <p className="text-center text-gray-600 mb-8">
            Passons en revue et signons votre document.
          </p>

          {/* Primary actions */}
          <div className="flex flex-col gap-4">
            {byMail ? (
              <button
              onClick={() => handleShowHistory()}
                className="bg-secondary text-white px-6 py-2 rounded-full hover:bg-primary focus:outline-none"
              >
                Afficher l’historique
              </button>
            ) : (
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setIsActionOpen(false);
                }}
                className="bg-secondary text-white px-6 py-2 rounded-full hover:bg-primary focus:outline-none"
              >
                Signer maintenant
              </button>
            )}

            {/* Collapsible section */}
            <div
              id="additional-actions"
              ref={actionsRef}
              style={{
                maxHeight,
                overflow: "hidden",
                transition: "max-height 0.3s ease",
              }}
              className="border-t pt-4 mt-6 space-y-4"
            >
              {/* Share */}
              {!byMail && (
                <>
                  <div className="flex items-center gap-2">
                    <CiShare1 />
                    <button
                      className="text-gray-600"
                      onClick={() => {
                        setIsActionOpen(false);
                        setIsShareOpen(true);
                      }}
                    >
                      Partager le document
                    </button>
                  </div>
                  {/* Copy */}
                  <div className="flex items-center gap-2">
                    <FaRegCopy />
                    <button
                      className="text-gray-600"
                      onClick={handleCopyDocument}
                    >
                      Copier
                    </button>
                  </div>
                  {/* History */}
                  <div className="flex items-center gap-2">
                    <CiTimer />
                    <button
                      className="text-gray-600"
                      onClick={() => handleShowHistory()}
                    >
                      Afficher l’historique
                    </button>
                  </div>
                </>
              )}

              {/* Rename */}
              {!byMail && (
                <div className="flex items-center gap-2">
                  <FaTextWidth />
                  <button
                    className="text-gray-600"
                    onClick={() => setIsRenameOpen(true)}
                  >
                    Renommer le document
                  </button>
                </div>
              )}

              {/* Print */}
              <div className="flex items-center gap-2">
                <IoPrintOutline />
                <button className="text-gray-600" onClick={handlePrintDocument}>
                  Imprimer le document
                </button>
              </div>

              {/* Download */}
              <div className="flex items-center gap-2">
                <AiOutlineCloudDownload />
                <button
                  className="text-gray-600"
                  onClick={handleExportDocument}
                >
                  Exporter le document
                </button>
              </div>
            </div>
            {/* Toggle button */}
            <button
              aria-expanded={showActions}
              aria-controls="additional-actions"
              onClick={() => setShowActions((prev) => !prev)}
              className="w-[60%] flex items-center self-center justify-center gap-2 border-1 border-secondary text-secondary px-3 py-1 rounded-full hover:bg-secondary/10 focus:outline-none"
            >
              {showActions ? (
                <>
                  Moins d'options <IoChevronUp className="text-lg" />
                </>
              ) : (
                <>
                  Autres options <IoChevronDown className="text-lg" />
                </>
              )}
            </button>
          </div>
        </div>
      </EsignModal>

      {/* Rename & Duplicate modals stay unchanged */}
      <Dialog
        open={isDuplicateOpen}
        onClose={() => setIsDuplicateOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: { px: 3, py: 2, borderRadius: 3 },
        }}
      >
        {/* ---------- Title with icon + close button ---------- */}
        <DialogTitle
          sx={{
            p: 0,
            mb: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            position: "relative",
            gap: 1,
            mt: 1,
          }}
        >
          <div className="flex items-center gap-5">
            <ContentCopyIcon fontSize="large" sx={{ color: "grey" }} />
            Copier
          </div>
          <IconButton
            aria-label="Fermer"
            onClick={() => setIsDuplicateOpen(false)}
            sx={{ position: "absolute", right: 0, top: 0 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        {/* ---------- Body ---------- */}
        <DialogContent dividers>
          <Stack spacing={2}>
            <Typography variant="h6" align="center" fontWeight="bold">
              Donner un nom à votre copie
            </Typography>

            <TextField
              label="Nom"
              fullWidth
              value={name}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
              autoFocus
            />

            <Typography
              variant="body2"
              color="text.secondary"
              align="center"
              sx={{ mt: 0.5 }}
            >
              La copie ne sera pas signée, mais tout le reste sera dupliqué
            </Typography>
          </Stack>
        </DialogContent>

        {/* ---------- Actions ---------- */}
        <DialogActions sx={{ p: 3, pt: 2 }}>
          <Button
            fullWidth
            size="large"
            variant="contained"
            onClick={createDuplicateDocument}
            disabled={!name.trim()}
            sx={{
              /** custom orange – tweak to match your brand */
              backgroundColor: "green",
              ":hover": { backgroundColor: "#c46e0e" },
              textTransform: "none",
              fontWeight: 600,
            }}
          >
            Copier
          </Button>
        </DialogActions>
      </Dialog>
      {/* Rename Document Modal */}
      <EsignModal isOpen={isRenameOpen} onClose={() => setIsRenameOpen(false)}>
        <div className="p-4 w-80">
          <h3 className="text-xl font-bold mb-4">Renommer le document</h3>
          <input
            type="text"
            value={newDocName}
            onChange={(e) => setNewDocName(e.target.value)}
            placeholder="Nouveau nom du document"
            className="w-full p-2 border border-gray-300 rounded mb-4"
          />
          <div className="flex justify-end gap-2">
            <button
              onClick={() => setIsRenameOpen(false)}
              className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-100"
            >
              Annuler
            </button>
            <button
              onClick={submitRename}
              className="px-4 py-2 bg-secondary text-white rounded hover:bg-primary"
            >
              Renommer
            </button>
          </div>
        </div>
      </EsignModal>
      <DocumentHistory
        documentId={docId}
        userData={currentUser?.data || currentUser}
        open={isHistoryOpen}
        onClose={() => setIsHistoryOpen(false)}
        documentData={documentData}
        history={history}
      />
    </>
  );
};

export default ActionModal;
